module.exports = __webpack_public_path__ + "media/images/cart-61eb46c6ad98ba371a79c9db72a980a5.png";